export const LOADED = 'loaded';
export const LOADING = 'loading';
export const ERROR = 'error';
